import { Icon, IconButton, Tooltip } from "@mui/material";
import { ModalOpenButton } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { PdsSyncEntityType } from "../../../clients/graphqlTypes.js";
import { PdsIcon } from "./PdsIcon.js";
import { PdsSyncReviewModal } from "./PdsSyncReviewModal.js";
import { PdsSyncReviewAccess } from "./usePdsSyncReviewAccess.js";

interface Props {
  access: PdsSyncReviewAccess;
  defaultEntityType: PdsSyncEntityType;
}

/**
 * Toolbar entry point (design D2) — first in the toolbar, visually separated
 * from "Import CRM data" by the caller (a Divider/spacing in CrmAll/CrmPersons)
 * to avoid the icon-adjacency misclick risk.
 */
export function PdsSyncToolbarButton({ access, defaultEntityType }: Props) {
  const { t } = useTranslate(["Integrations"]);

  if (!access.isEnabled) return null;

  return (
    <ModalOpenButton
      Modal={PdsSyncReviewModal}
      modalProps={{
        access,
        defaultEntityType,
        initialTab: "toReview" as const,
      }}
    >
      <IconButton
        size="small"
        color="primary"
        aria-label={t("View PDS sync log", { ns: "Integrations" })}
      >
        <Tooltip title={t("View PDS sync log", { ns: "Integrations" })}>
          <Icon>
            <PdsIcon />
          </Icon>
        </Tooltip>
      </IconButton>
    </ModalOpenButton>
  );
}
